/* eslint-disable @typescript-eslint/no-use-before-define */
import {
    Action,
    ActionReducerMap,
    createFeatureSelector,
    createSelector,
    StoreModule,
} from '@ngrx/store';
import { Favorite } from 'src/app/models/favorite';
import {
    CreateFavorite,
    DeleteFavorite,
    FavoriteAction,
    ForceFavoriteRefresh,
    SetFavorites,
    UpdateFavorite,
} from './community-favorite.actions';

export interface FavoriteState {
    favorites: Favorite[];
    forceRefresh: boolean;
}

const reducerMap: ActionReducerMap<FavoriteState> = {
    favorites: favoritesReducer,
    forceRefresh: forceRefreshReducer,
};

export const selectFavoriteState =
    createFeatureSelector<FavoriteState>('favorite');
export const selectFavorites = createSelector(
    selectFavoriteState,
    (state) => state.favorites
);
export const selectShouldForceFavoriteRefresh = createSelector(
    selectFavoriteState,
    (state) => state.forceRefresh
);

export const communityFavoriteStoreModule = StoreModule.forFeature(
    'favorite',
    reducerMap
);

function favoritesReducer(state: Favorite[] = [], action: Action) {
    let index: number;

    switch (action.type) {
        case FavoriteAction.createFavorite:
            return [...state, (action as CreateFavorite).favorite];
        case FavoriteAction.deleteFavorite:
            return state.filter(
                (favorite) =>
                    favorite.id !== (action as DeleteFavorite).favoriteId
            );
        case FavoriteAction.setFavorites:
            return [...(action as SetFavorites).favorites];
        case FavoriteAction.updateFavorite:
            // order of favorites in array is critical
            index = Math.max(
                0,
                state.findIndex(
                    (favorite) =>
                        favorite.id === (action as UpdateFavorite).favorite.id
                )
            );
            return [
                ...state.slice(0, index),
                (action as UpdateFavorite).favorite,
                ...state.slice(index + 1),
            ];

        default:
            return state;
    }
}

function forceRefreshReducer(state = true, action: Action) {
    switch (action.type) {
        case FavoriteAction.forceFavoriteRefresh:
            return (action as ForceFavoriteRefresh).forceRefresh;
        default:
            return state;
    }
}
